const Header = () => {
    
    return(
        <header>
            <h1 className="animate pop logo">Sun Run</h1>
        </header>
    )
}

export default Header;